import styled from 'styled-components';

export const StyledInstruments = styled.section`
    position: relative;
    background: ${props => props.background || '#fff'};
	padding-bottom: 200px;
	@media(max-width: 767px){
		padding-bottom: 90px;
	}
	&:last-of-type(odd){
        background: ${props => props.background || '#EFEFEF'};
		
	}

    .header {
        padding-top: 40px;
        position: relative;
        margin-bottom: 40px;

        &:after {
            position: absolute;
            width: 100%;
            background: #15263780;
            height: 1px;
            left: 0;
            right: 0;
            top: 0;
            content: '';
        }

        p {
            color: #15263780;
        }
    }

    .title {
        color: #152637;

        i {
            color: #DD223F;
        }
    }

    p {
        font-weight: 400;
        font-size: 1rem; /* 16px */
        line-height: 1.5rem; /* 24px */
        letter-spacing: 0; /* 0% */
    }

    .col-md-3{
        position: relative;
		margin-bottom: 40px;
        @media(max-width: 767px){
            margin-bottom: 30px;
        }
        a{
            position: absolute;
            inset: 0;
            width: calc(100% - 15px);
            height: calc(100% - 15px);
            z-index: 2;
        }
        .single-item {
            position: relative;
            background: #FFFFFF;
            border-radius: 5px;
            overflow: hidden;
            border: 1px solid rgba(21, 38, 55, 0.5);
            padding: 15px;
            .item-image {
                position: relative;
				padding-top: calc(270/270 * 100%);
				img{
					object-fit: contain;
					position: absolute;
					inset: 0;
					width: 100%;
					height: 100%;
				}

            }


        }
        p{
            font-weight: 500;
            font-size: 1.25rem;      /* 20px */
            line-height: 1.75rem;    /* 28px */
            letter-spacing: 0;
            color: #152637;
            margin: 10px 0 0;
        }

        .subtitle-ygen {
            color: rgba(21, 38, 55, 0.5);
            font-size: 1rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.5rem;
        }

    }

    @media (max-width: 767px) {
        .margin-top-60 {
            margin-top: 60px;
        }
    }

    &.version {
        background: #EFEFEF;

        .title {
            i {
                color: #152637;
            }
        }
    }

    ul {
        margin-top: 40px;

        li {
            border-bottom: 1px solid #152637;
            padding-bottom: 10px;
            margin-bottom: 10px;
            color: #152637;
            font-weight: 400;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0em; /* 0% */
            position: relative;
            counter-increment: count;
            padding-left: 32px;

            &:before {
                width: 20px;
                height: 20px;
                background: #DD223F;
                content: counter(count, decimal);
                font-weight: 400;
                font-size: 1rem; /* 16px ÷ 16 */
                line-height: 1.5rem; /* 24px ÷ 16 */
                letter-spacing: 0;
                position: absolute;
                color: white;
                left: 0;
                top: 5px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

`;
